import { useSearchParams } from 'react-router-dom'

export type OrgTab = 'units' | 'types'

/**
 * The Organization section's URL state (TO-389 organization-admin-ui, Contract
 * "Routes"): `tab` (units default | types), `unit` (the selected unit id) and
 * `q` (the trimmed search query). Updates replace the history entry.
 */
export function useOrgUrlState() {
	const [params, setParams] = useSearchParams()
	const update = (mutate: (next: URLSearchParams) => void) =>
		setParams(
			(prev) => {
				const next = new URLSearchParams(prev)
				mutate(next)
				return next
			},
			{ replace: true },
		)
	const setOrDelete = (next: URLSearchParams, key: string, value: string | null) =>
		value ? next.set(key, value) : next.delete(key)
	return {
		tab: (params.get('tab') === 'types' ? 'types' : 'units') as OrgTab,
		unitId: params.get('unit'),
		q: params.get('q') ?? '',
		setTab: (tab: OrgTab) => update((next) => setOrDelete(next, 'tab', tab === 'types' ? tab : null)),
		selectUnit: (id: string | null) => update((next) => setOrDelete(next, 'unit', id)),
		setQuery: (query: string) => update((next) => setOrDelete(next, 'q', query.trim() || null)),
	}
}
